/* eslint-disable import/prefer-default-export */

export const TYPED_SEARCH_TERM_UPDATED = 'TYPED_SEARCH_TERM_UPDATED';
export const SEARCHED_SEARCH_TERM_UPDATED = 'SEARCHED_SEARCH_TERM_UPDATED';
export const FILTER_UPDATED = 'FILTER_UPDATED';
export const CLEAR_FILTER_VALUES = 'CLEAR_FILTER_VALUES';
export const DATA_TABLE_EL_CHANGED = 'DATA_TABLE_EL_CHANGED';
